export const masterContants = {
  SET_STATE_MASTER: "SET_STATE_MASTER",
  SET_DEFAULT_MASTER: "SET_DEFAULT_MASTER",
  GET_ALL_MASTER: "GET_ALL_MASTER",
};
